import PropTypes from 'prop-types';

import monthlyPriceShape from './monthlyPrice';

export default {
  price: PropTypes.number,
  currencyLabel: PropTypes.string.isRequired,
  monthlyPrice: PropTypes.shape(monthlyPriceShape).isRequired
};
